export default __webpack_public_path__ + "static/media/WeD9.a8d18917.png";